import { apiErrorCode } from '../../../utils/apiError';

export type RushMidErrorKey =
  | 'partyErrNotFound'
  | 'partyErrInGame'
  | 'partyErrFull'
  | 'partyErrInMatch'
  | 'maintenanceErr'
  | 'balanceErr'
  | 'multiaccErr';

// WHY: MULTIACC_NOT_ALLOWED намеренно ведёт на размытый текст — точная причина подсказала бы, как обойти защиту (#516)
const ERR_KEY = new Map<string, RushMidErrorKey>([
  ['PARTY_NOT_FOUND', 'partyErrNotFound'],
  ['PARTY_IN_GAME', 'partyErrInGame'],
  ['PARTY_FULL', 'partyErrFull'],
  ['IN_ACTIVE_MATCH', 'partyErrInMatch'],
  ['MAINTENANCE', 'maintenanceErr'],
  ['INSUFFICIENT_RESOURCES', 'balanceErr'],
  ['MULTIACC_NOT_ALLOWED', 'multiaccErr'],
]);

export function rushMidErrorKey(err: unknown): RushMidErrorKey | undefined {
  const code = apiErrorCode(err);
  return code ? ERR_KEY.get(code) : undefined;
}
